import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { imgBaseUrl } from "../../Const";
import { IoClose } from "react-icons/io5";

export default function VideoModal({ show, handleHide, propertyVdosmdl, id }) {
    useEffect(() => {
        const resizeObserverError = (event) => {
            if (event.message === "ResizeObserver loop completed with undelivered notifications.") {
                event.stopImmediatePropagation();
            }
        };
        window.addEventListener("error", resizeObserverError);
        return () => {
            window.removeEventListener("error", resizeObserverError);
        };
    }, []);
    return (
        <Modal size="xl" className="video-modal modal-overlay" aria-labelledby="contained-modal-title-vcenter " show={show} centered>
            <button className="close-btn" onClick={handleHide}>
                <IoClose />
            </button>
            <Modal.Body>
                <div className="modal-slider-container video-slide accordion-swiper-modal">
                    <Swiper
                        modules={[Navigation]}
                        spaceBetween={20}
                        slidesPerView={1}
                        initialSlide={id}
                        navigation
                        loop={false}
                        observer={false}
                        observeParents={false}
                        resizeObserver={false}
                        className="swiper-container"
                    >
                        {propertyVdosmdl.length > 0 &&
                            propertyVdosmdl
                                .filter((img) => !img.needHide)
                                .sort((a, b) => {
                                    if (a.isCover) return -1;
                                    if (b.isCover) return 1;
                                    return a.orderRank - b.orderRank;
                                })
                                .map((slide, index) => (
                                    <SwiperSlide key={index}>
                                        <video controls className="">
                                            <source src={imgBaseUrl + slide?.path} type="video/mp4" />
                                        </video>
                                    </SwiperSlide>
                                ))}
                    </Swiper>
                </div>
            </Modal.Body>
        </Modal>
    );
}
